import React from 'react'
import styles from './styles'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { loggedInSelector, userEmailSelector } from '../../selectors/users'
import { logout } from 'spa/action_creators/current_user'

const LogoutButton = () => {
  const dispatch = useDispatch()
  const isLoggedIn = useSelector(loggedInSelector)
  const userEmail = useSelector(userEmailSelector)

  if (!isLoggedIn) return null

  return (
    <a className={styles.logoutLink} onClick={() => dispatch(logout())}>
      <FormattedMessage
        id="djcity.common.sunset.logout"
        defaultMessage="Logout: {email}"
        values={{ email: userEmail }}
      />
    </a>
  )
}

export default LogoutButton
